import React from "react";
import moment from "moment";
import 'moment/locale/id';

const DetailPurchaseOrder = (props) => {
  const { purchaseOrder, visible } = props;
  const supplier = purchaseOrder?.supplier ?? {};
  return (
    <>
      {visible && (
        <>
          <hr className="my-4 w-75 align-center mx-auto" />
          <h5 className="text-center mx-auto mb-3">
            Detail Purchase Order
          </h5>
          <div className="container w-75">
            <DataPO label={"Supplier/Vendor"} value={supplier?.name} />
            <DataPO label={"Alamat Pengantaran"} value={purchaseOrder?.internalShipmentAddress} />
            <DataPO label={"Estimasi Pengantaran"} value={purchaseOrder.expectedTimeArrival ? moment(purchaseOrder?.expectedTimeArrival).format('D MMMM YYYY, HH:mm [WIB]') : '-'} />
          </div>
        </>
      )}
    </>
  );
};

const DataPO = ({ label, value }) => {
  return (
    <div className="row mx-auto my-2">
      <div className="col-3">{label}</div>
      <div className="col-1">{":"}</div>
      <div className="col-8">{value ?? '-'}</div>
    </div>
  );
};

export default DetailPurchaseOrder;

